/**
 * Offline authentication: none. The launcher serves the app on loopback with
 * no network, so the user is always considered authenticated and anonymous.
 */
import React from 'react';

// Logout has nothing to end in offline mode.
const noop = () => {};

// No identity provider, hence no ID token.
const resolveNull = () => Promise.resolve(null);

// Stable reference: consumers use these fields as effect dependencies.
const OFFLINE_AUTH = Object.freeze({
  isAuthenticated: true,
  isLoading: false,
  user: null,
  logout: noop,
  getIdTokenClaims: resolveNull,
});

// Transparent provider: renders its children unchanged.
export const AppAuthProvider = ({ children }) => <>{children}</>;

// Returns the constant anonymous auth state.
export const useAppAuth = () => OFFLINE_AUTH;

// Guard that never redirects: returns the wrapped component as is.
export const withAppAuthRequired = Component => Component;
